<div class="container mbTopbanner" id="mbTopbanner">
    <ng-container>
        <main><h1>Dell India's official store locator.</h1>
        <h2>
            Look for Dell Exclusive Stores near you & get automated directions.
        </h2></main>
    </ng-container>


    <div class="searchWrap">
        <div class="searchInfo">
            <button class="locateMeBtn"  tabindex="0" on-click="locateMe($event, 'currentLocation')"> Locate Me</button>
            <p>
                To access closest of the <strong>600+ Dell</strong> Exclusive Stores in India
            </p>
        </div>

        <div class="mainSearchWrapper">
            <span class="searchRadio">
          <label for="stores">
            <input
              type="radio"
              id="stores"
              name = "storeservice"
              checked
            />
            <span>Stores</span>
            </label>
            </span>
            <input type="text" #search class="mtmInput" tabindex="0" placeholder="Search location" [value]="searchValue" (keyup)="enableFindStoreBtn1($event,search.value)" />

            <!-- <ul id="myUL" *ngIf="isLoading">
                <li>
                    Loading...
                </li>
            </ul> -->
            <ng-container *ngIf="storeList && storeList.length > 0;">
                <ul id="myUL" role="menu" aria-label="menu">
                    <li role="menuitem" tabindex="0" class="mnu-item" *ngFor="let list of storeList" (mousedown)="currentLocationStores(list)" (keydown.enter)="currentLocationStores(list)">
                        <img src="../../../assets/img/searchIcon.svg" alt="" style="padding: 0 8px 0 0;"> <span>{{ list.description }}</span>
                    </li>
                </ul>
            </ng-container>
            <span class="searchBtnwrap">
          <button [disabled]="findBtn" (click)="enableFindStoreBtn(search.value)" class="gradientBtn" >Find Stores
            <img height="1" width="1" style="border-style:none;" alt="" src="https://insight.adsrvr.org/track/pxl/?adv=ev5teqd&ct=0:pu9jpe6&fmt=3"/>

          </button>
        </span>
        </div>

    </div>
</div>
<div class="container mobileP0" *ngIf="topbanner">
    <div class="popularCity">
        <h3 *ngIf="show">View Stores by City</h3>
        <div class="">
            <div class="popularCityslider">
                <ul class="plList bigarrow">
                    <li>
                        <a href="#" on-click="locateMe($event,'Kolkata')">
                            <em class="Kolkata"></em>
                            <strong>Kolkata</strong>
                        </a>
                    </li>
                    <li>
                        <a href="#" on-click="locateMe($event, 'Mumbai')">
                            <em class="mumbai"></em>
                            <strong>Mumbai</strong>
                        </a>
                    </li>
                    <li>
                        <a href="#" on-click="locateMe($event,'Delhi')">
                            <em class="delhi"></em>
                            <strong>Delhi</strong>
                        </a>
                    </li>
                    <li>
                        <a href="#" on-click="locateMe($event,'Bangalore')">
                            <em class="banglore"></em>
                            <strong>Bangalore</strong>
                        </a>
                    </li>
                    <li>
                        <a href="#" on-click="locateMe($event,'Hyderabad')">
                            <em class="Hyderabad"></em>
                            <strong>Hyderabad</strong>
                        </a>
                    </li>
                    <li>
                        <a href="#" on-click="locateMe($event,'Chennai')">
                            <em class="Chennai"></em>
                            <strong>Chennai</strong>
                        </a>
                    </li>

                </ul>
            </div>
        </div>
    </div>
</div>